// extracted by mini-css-extract-plugin
export default {"container":"components-parity-tables-table-issues-module__container"};